export const AUTH_USER = 'auth_user';
export const UNAUTH_USER = 'unauth_user';
export const AUTH_USER_REQUEST = 'auth_user_request';
export const AUTH_USER_SUCCESS = 'auth_user_success';
export const AUTH_USER_FAILURE = 'auth_user_failure';